const ForkIcon = () => {
  return (
    <svg fill="none" viewBox="0 0 22 22" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2.83333 8.5L4.55228 10.219C5.05238 10.719 5.73713 11.03 6.43113 10.8937L7.95204 10.3599L17.4267 19.8346C18.0917 20.4996 19.1697 20.4996 19.8346 19.8346C20.4996 19.1697 20.4996 18.0917 19.8346 17.4267L10.3599 7.95204L10.8937 6.43113C11.03 5.73713 10.719 5.05238 10.219 4.55228L8.5 2.83333M2.83333 8.5L1 6.66667M2.83333 8.5C5.60417 5.72917 4.82245 4.82245 3.78105 3.78105M3.78105 3.78105L3.66667 3.66667M3.78105 3.78105C4.82245 4.82245 6.51089 4.82245 7.55228 3.78105L8.5 2.83333M8.5 2.83333L6.66667 1"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
    </svg>
  )
}

export default ForkIcon
